import { z } from 'zod';

import zodLocales from 'common/zod/locales';

export const fiscalIdFormSchema = z.string().trim();

export const fiscalIdOptionalFormSchema = fiscalIdFormSchema.optional();

export const fiscalIdRequiredFormSchema = fiscalIdFormSchema.min(1, {
  message: zodLocales.errors.required,
});

export const fiscalIdValidationSchema = z.object({
  fiscalId: fiscalIdRequiredFormSchema,
});

export type FiscalIdFormSchema = z.infer<typeof fiscalIdValidationSchema>;
